"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _formElements = require("@evidation/form-elements");
var _TextInput = require("./TextInput");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _hintText = _interopRequireDefault(require("./hintText"));
var _lib = require("../../lib");
var _utils = require("../utils");
var _excluded = ["required", "label", "labelStyle", "error", "labelTooltip", "name", "id", "className", "unit", "hint_text", "srOnly", "showErrorBorder", "onBlur", "onInputBlur", "schemaHasHeading", "numberOfInputs", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NumberInput = function NumberInput(_ref) {
  var required = _ref.required,
    label = _ref.label,
    labelStyle = _ref.labelStyle,
    error = _ref.error,
    labelTooltip = _ref.labelTooltip,
    name = _ref.name,
    id = _ref.id,
    className = _ref.className,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? '' : _ref$unit,
    hint_text = _ref.hint_text,
    srOnly = _ref.srOnly,
    _ref$showErrorBorder = _ref.showErrorBorder,
    showErrorBorder = _ref$showErrorBorder === void 0 ? true : _ref$showErrorBorder,
    onBlur = _ref.onBlur,
    onInputBlur = _ref.onInputBlur,
    schemaHasHeading = _ref.schemaHasHeading,
    numberOfInputs = _ref.numberOfInputs,
    value = _ref.value,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var uniqueId = (0, _react.useMemo)(function () {
    return "".concat(id || name).concat(!(0, _utils.isEmpty)(unit) ? "_".concat(String(unit).toLocaleLowerCase()) : '');
  }, [id, name, unit]);
  (0, _react.useEffect)(function () {
    if (value === 'set_by_exclusive_input') {
      setInputValue('');
    } else {
      setInputValue(value);
    }
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])('number-input--container', error && showErrorBorder && 'evi--fieldset-error')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "number-input--field-container"
  }, !schemaHasHeading && numberOfInputs === 1 ? /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
    id: "t-label-".concat(uniqueId),
    schemaHasHeading: schemaHasHeading,
    numberOfInputs: numberOfInputs
  }, (0, _utils.stripHtml)(label)) : /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: uniqueId,
    className: "basic-label"
  }, (0, _utils.stripHtml)(label || '')), hint_text ? /*#__PURE__*/_react["default"].createElement(_hintText["default"], {
    text: hint_text,
    id: "t-".concat(uniqueId, "_hint")
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    role: "alert",
    id: "t-".concat(uniqueId, "_error-message_")
  }, error && showErrorBorder && /*#__PURE__*/_react["default"].createElement(_lib.InputError, null, error)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "number-input--field"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput.Input, (0, _extends2["default"])({
    id: uniqueId,
    inputMode: 'numeric',
    name: name
  }, rest, {
    value: inputValue,
    "aria-details": !(0, _utils.isEmpty)(unit) ? 'number-input-unit' : undefined,
    type: "tel",
    pattern: "^-?[0-9]\\d*(\\.\\d+)?$",
    "aria-required": required,
    required: required,
    className: (0, _clsx["default"])('number-input--input', className, error && 'evi-error--border'),
    "aria-describedby": "t-".concat(uniqueId, "_error-message_ ").concat(hint_text ? "t-".concat(uniqueId, "_hint") : '')
    // If we are using `legend` tag, bind the input with the legend id, else, we use the `label` tag and a bind is not needed
    ,
    "aria-labelledby": !schemaHasHeading && numberOfInputs === 1 ? "t-label-".concat(uniqueId) : undefined,
    "aria-roledescription": !schemaHasHeading && numberOfInputs === 1 ? undefined : (0, _utils.stripHtml)(label),
    step: "any",
    onBlur: onInputBlur
  })), !(0, _utils.isEmpty)(unit) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "number-input--unit-container"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    role: "definition",
    id: "number-input-unit"
  }, unit)))));
};
NumberInput.propTypes = {
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].oneOf(_constants.TextInputTypes),
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object,
  error: _propTypes["default"].string
};
NumberInput.defaultProps = {
  inputStyle: "achievement",
  labelStyle: "dark",
  style: {},
  error: "",
  value: ""
};
var _default = exports["default"] = NumberInput;